export const getPortalSource = () => process.env.PROJECT_NAME ?? 'sendfx';

export const withPortalSource = (entity) => {
  return {
    ...entity,
    portalSource: getPortalSource(),
  };
};
